export enum AppRoutes {
  LOGIN = 'login',
  SIGNUP = 'sign-up',
  CAR_DETAILS = 'booking/car/details',
  MY_BOOKING = 'my-booking',
  PAYMENT = 'payment',
}
